export default __webpack_public_path__ + "static/media/O0002.d1c18699.png";